import {ServiceBase} from '../../ServiceBase';
import {IServiceFactoryExtended} from '../../service-factory-extended.interface';
import {ActionID, IPerformActionTopicPayload,} from '@sparkware/uc-sdk-core';
import {IActionHandler} from "./action-handler.interface";
import {OpenBankingActionHandler} from "./handlers/open-banking.action-handler";
import {UploadDocumentsActionHandler} from "./handlers/upload-documents.action-handler";
import {OpenDepositActionHandler} from "./handlers/open-deposit.action-handler";
import {OpenWithdrawActionHandler} from "./handlers/open-withdraw.action-handler";
import {OpenLinkActionHandler} from "./handlers/open-link.action-handler";
import {OpenChatActionHandler} from "./handlers/open-chat.action-handler";
import {OpenLinkWithFormPostActionHandler} from "./handlers/open-link-with-form-post.action-handler";

export class CasinofiedActionHandlerService extends ServiceBase {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        services.messageBroker.channels.navigation.topics.performAction.subscribe(this._performActionHandler);
    }

    private _performActionHandler = async (payload: IPerformActionTopicPayload): Promise<void> => {
        const actionHandler = this._createActionHandler(payload.actionID);
        await actionHandler.handle(payload);
    }

    private _createActionHandler(actionId: ActionID): IActionHandler {
        switch (actionId) {
            case ActionID.openBanking:
                return new OpenBankingActionHandler(this.services);
            case ActionID.uploadDocuments:
                return new UploadDocumentsActionHandler(this.services);
            case ActionID.deposit:
                return new OpenDepositActionHandler(this.services);
            case ActionID.withdraw:
                return new OpenWithdrawActionHandler(this.services);
            case ActionID.openLink:
                return new OpenLinkActionHandler(this.services);
            case ActionID.openChat:
                return new OpenChatActionHandler(this.services);
             case ActionID.openEmail:
                 return new OpenLinkWithFormPostActionHandler(this.services);
             case ActionID.openOnlineHelp:
                 return new OpenLinkWithFormPostActionHandler(this.services);
            default:
                throw new Error(`Casinofied ${actionId} is not supported`);
        }
    }
}
